var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    x: 3.5,
    y: 4.5,
    fill: "#fff",
    stroke: "#2081E2",
    strokeWidth: 3,
    rx: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#95E6F2",
    stroke: "#2081E2",
    strokeWidth: 2,
    d: "M27 15.5C27 17.433 25.433 19 23.5 19C21.567 19 20 17.433 20 15.5C20 13.567 21.567 12 23.5 12C25.433 12 27 13.567 27 15.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#95E6F2",
    stroke: "#2081E2",
    strokeWidth: 2,
    d: "M17 25.5C17 27.433 15.433 29 13.5 29C11.567 29 10 27.433 10 25.5C10 23.567 11.567 22 13.5 22C15.433 22 17 23.567 17 25.5Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 2,
    y: 3,
    fill: "#1868B7",
    rx: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M28 15.5C28 17.9853 25.9853 20 23.5 20C21.0147 20 19 17.9853 19 15.5C19 13.0147 21.0147 11 23.5 11C25.9853 11 28 13.0147 28 15.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M18 25.5C18 27.9853 15.9853 30 13.5 30C11.0147 30 9 27.9853 9 25.5C9 23.0147 11.0147 21 13.5 21C15.9853 21 18 23.0147 18 25.5Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    x: 24,
    y: 23,
    fill: "#2BCDE4",
    rx: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M52 34.5C52 36.9853 49.9853 39 47.5 39C45.0147 39 43 36.9853 43 34.5C43 32.0147 45.0147 30 47.5 30C49.9853 30 52 32.0147 52 34.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M39 34.5C39 36.9853 36.9853 39 34.5 39C32.0147 39 30 36.9853 30 34.5C30 32.0147 32.0147 30 34.5 30C36.9853 30 39 32.0147 39 34.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M52 46.5C52 48.9853 49.9853 51 47.5 51C45.0147 51 43 48.9853 43 46.5C43 44.0147 45.0147 42 47.5 42C49.9853 42 52 44.0147 52 46.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M39 46.5C39 48.9853 36.9853 51 34.5 51C32.0147 51 30 48.9853 30 46.5C30 44.0147 32.0147 42 34.5 42C36.9853 42 39 44.0147 39 46.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon (8).e88cf20365e45287982f7ce24c8650cb.svg";
export { ForwardRef as ReactComponent };